export default [
    {title: "General.PaymentMethod.Cash", value: "cash"},
    {title: "General.PaymentMethod.CarBalance", value: "car balance"}
]
